<template>
  <div class="container d-table">
    <div class="d-100vh-va-middle">
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <div class="card-group">
            <div class="card p-2">
              <div class="card-block">
                <img src="../../../static/assets/img/logo.png" height="50">
                <div v-if="loading" class="mt-3">
                  <Loading></Loading>
                </div>
                <form v-on:submit.prevent="login">
                  <p class="text-muted">{{ t.navigation.login }}</p>
                  <div class="input-group mb-1">
                    <span class="input-group-addon">
                    <i class="icon-user"></i>
                    </span>
                    <input type="text" name="username" class="form-control" :placeholder="t.user.username" v-model="username">
                  </div>
                  <div class="input-group mb-2">
                    <span class="input-group-addon">
                    <i class="icon-lock"></i>
                    </span>
                    <input type="password" name="password" class="form-control" :placeholder="t.user.password" v-model="password">
                  </div>
                  <div class="row">
                    <div class="col-xs-6">
                      <input id="log" name="log" type="hidden" value=""/>
                      <button type="submit" name="login" value="button" class="btn btn-primary px-2">{{ t.login }}</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="card card-inverse card-primary py-3 hidden-md-down" style="width:44%">
              <div class="card-block text-xs-center">
                <div>
                  <h2>{{ t.welcome }}</h2>
                  <!-- <p>Sisteme giriş yapmak için<br>kullanıcı bilgilerinizi giriniz.</p>  -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Locale />
    </div>
    <link href="../../../static/assets/bower_components/simple-line-icons/css/simple-line-icons.css" rel="stylesheet">
  </div>
</template>

<script>
import Loading from "../Loading";
import Locale from "../widget/locale"
export default {
  name: "Login",
  components: {Loading,Locale},
  data() {
    return {
      t: this.$root.t,
      username: null,
      password: null,
      loginError: false,
      blurred: false,
      session: session,
      loading: false
    }
  },
  beforeMount() {
    if(this.$route.query.redirect === 'logout'){
      this.$route.query.redirect = '';

      window.location.reload();
    }
  },
  mounted() {
    this.isLogged();

    if(!this.t)
      window.location.reload();
  },
  methods: {
    getClient() {
      return this.$http.get(api + 'api/v1/get/client');
    },
    isLogged() {

      var th = this;
      this.$getItem('auth', function (key, value) {

        th.$http.get(api + 'oauth/v2/token',
            {
              params: {
                client_id: value.client, client_secret: value.clientSecret, grant_type: 'refresh_token',
                refresh_token: value.refreshToken
              }
            }).then(
            response => {

              window.accessTokenHeader = response.body.access_token;
              window.auth.accessToken = response.body.access_token;
              window.auth.refreshToken = response.body.refresh_token;
              window.auth.client = value.client;
              window.auth.clientSecret = value.clientSecret;

              th.$setItem('auth', window.auth);
              th.$router.replace('/');

            }, response => {
              th.blurred = false;
            });

      }, function (err) {

      })
    },
    login() {
      this.loading = true;
      if (this.password && this.username) {
        this.loginError = false;
        this.blurred = true;
        this.$bus.$emit('globalLoader', false);

        this.getClient().then(response => {
          this.clientId = response.body.client_id;
          this.clientSecret = response.body.client_secret;

          if(this.clientId && this.clientSecret){
            this.$http.get(api + 'oauth/v2/token',
                {
                  params: {
                    client_id: this.clientId, client_secret: this.clientSecret, grant_type: 'password',
                    username: this.username, password: this.password
                  }
                }).then(
                response => {

                  window.accessTokenHeader = response.body.access_token;
                  window.auth.accessToken = response.body.access_token;
                  window.auth.refreshToken = response.body.refresh_token;

                  this.$setItem('auth', window.auth);
                  this.blurred = false;
                  this.loading = false;

                  this.$parent.getUserSession()

                  setTimeout(() => {
                    this.$router.replace('/');
                  }, 1500);

                }, response => {
                  this.loginError = true;
                  this.blurred = false;
                  this.loading = false;
                  this.$fire({
                    title: "Oppps!",
                    text: "Sistemde boyle bir kullanici bulunamadi.",
                    type: "error",
                    timer: 3000
                  }).then(r => {

                  });
                });
          }


        }, response => {
          this.maintenance = true;
          this.error_msg = 'Client couldnt receiver the response.'
        })


        return false;
      }
    },
    forgotPassword() {
      this.$refs.fpmodal.open()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Login.vue